var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.64,
    y: 5.72,
    width: 65.65,
    height: 46.56,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.54,
    y: 3.62,
    width: 65.65,
    height: 46.56,
    fill: "#b3e7ff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "114.41 31.79 114.41 39.59 92.33 39.59 92.33 25.73 85.64 25.73 103.37 12.74 121.09 25.73 114.41 25.73",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 6.42,
    width: 65.65,
    height: 46.56,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 4.32,
    width: 65.65,
    height: 46.56,
    fill: "#ccefff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.3,22.55H161.62m13.81,12h16.38m-8.87-16a5.62,5.62,0,0,0,0,7.94m.59,0h7.95m-7-4h6.93m-8.45-4h7.95m-18.08,13a6,6,0,0,0-3.76-1.26c-2.94,0-6.84,1.93-6.84,4.31s3.9,4.31,6.84,4.31,5.32-1.93,5.32-4.31",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 59.54,
    width: 65.65,
    height: 46.56,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 57.44,
    width: 65.65,
    height: 46.56,
    fill: "#e6f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,94.06h-29V88.38a4.37,4.37,0,0,0,0-8.74V74h32.9v5.68a4.37,4.37,0,0,0,0,8.74v5.68m-12.81-4.45H178.8V79.17l-3.6,3.6m3.6,6.84h-3.37m15.81-19.25-1.47-5.49-20.48,5.49m7.06,3.51",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.79,
    y: 64.47,
    width: 65.65,
    height: 46.56,
    transform: "translate(-13.94 16.2) rotate(-10)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.54,
    y: 53.23,
    width: 65.65,
    height: 46.56,
    transform: "translate(-12.16 14.08) rotate(-10)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7,80.95a4.22,4.22,0,1,1-5.87,1M85.38,77.3a4.22,4.22,0,1,0,5.87-1m6.74-1-1.79.32-2.6-6.72-5.43,1-5.09-5.54L71,66.45l-4.81,7.29-11.34,2L54.13,83,52,83.42M54.13,83m12.3.63L80.8,81.14",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.5574ad9c.svg";
export { ForwardRef as ReactComponent };